export default __webpack_public_path__ + "fonts/SF-Pro-Text-Semibold.woff2";